module.exports = __webpack_public_path__ + "img/andrew-welcome.4d756433.png";